module.exports = __webpack_public_path__ + "static/media/support.b74d934b.png";